(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');

    // click-directive to show a task 
    module.directive('taskShow', ['TaskService',
        function (TaskService) {
            var directive = {
                link: link,
                restrict: 'A',
                scope: {
                    id: '=' // task id                    
                }
            };
            return directive;

            function link(scope, element) {

                // click listener
                element.on('click', function () {
                    show();
                });

                // show
                function show() {
                    TaskService.show(scope.id);
                } // show

                // on destroy
                scope.$on("$destroy", function () {
                    element.off("click");
                });

            }
        }]);

})();